import { TwinDictionary } from '../../globals/dictionary'
import useTwinTranslation from '../useTwinTranslation'

const useTicketVariables = () => {
    const {t} = useTwinTranslation()
    const separations: TwinDictionary = {
        '0': {name: 0, conversion: '0px'},
        '1': {name: 1, conversion: '20px'},
        '2': {name: 2, conversion: '40px'},
        '3': {name: 3, conversion: '60px'},
        '4': {name: 4, conversion: '80px'},
        '5': {name: 5, conversion: '100px'},
    }
    const fontSizes: TwinDictionary = {
        '0': { name: 0, conversion: '12px' },
        '1': { name: 1, conversion: '16px' },
        '2': { name: 2, conversion: '20px' },
        '3': { name: 3, conversion: '24px' },
        '4': { name: 4, conversion: '30px' },
    }
    const cellSizes: TwinDictionary = {
        '1': { name: 1, conversion: '12px' },
        '2': { name: 2, conversion: '16px' },
        '3': { name: 3, conversion: '20px' },
        '4': { name: 4, conversion: '24px' },
        '5': { name: 5, conversion: '30px' },
        '6': { name: 6, conversion: '30px' },
        '7': { name: 7, conversion: '30px' },
        '8': { name: 8, conversion: '30px' },
    }
    const fontWeights: TwinDictionary = {
        '400': { name: t('default', 'Por defecto') },
        '700': { name: t('bold', 'Negrita') }
    }
    const correction: TwinDictionary = {
        'L': { name: 'L(7%)' },
        'M': { name: 'M(15 %)' },
        'Q': { name: 'Q(25 %)' },
        'H': { name: 'H(30 %)' }
    }
    const model: TwinDictionary = {
        '1': { name: 'Model 1' },
        '2': { name: 'Model 2 (standard)' },
        '3': { name: 'Micro QR' },
    }
    const width: TwinDictionary = {
        '1': { name: 1},
        '2': { name: 2 },
        '3': { name: 3 },
        '4': { name: 4 },
        '5': { name: 5 },
    }
    const textTy: TwinDictionary = {
        '0': { name: t('notext', 'Sin texto')},
        '1': { name: t('textOnTop', 'Texto en la parte superior') },
        '2': { name: t('TextOnBottom', 'Texto en la parte inferior') },
        '3': { name: t('TextOnTopAndBottom', 'Texto en ambas partes ') },
    }

    const headerTicketBorder: TwinDictionary = {
        'none': { name: t('none', 'Ninguno'), conversion: {'border': '0px'}},
        'complete': { name: t('complete', 'Completo'), conversion: {'borderTop': '1px dashed black', 'borderBottom': '1px dashed black'} },
        'just-bot': { name: t('justBottom', 'Solo inferior'), conversion: {'borderBottom': '1px dashed black'} },
        'just-top': { name: t('justTop', 'Solo superior'), conversion: {'borderTop': '1px dashed black'} }
    }
    return { separations, fontSizes, fontWeights, headerTicketBorder, cellSizes, model, correction, width, textTy }
}

export default useTicketVariables